"use client";

import type { ReactNode } from "react";
import { ScrollPageShell } from "@/components/workspace/ScrollPageShell";

export default function WorkspacesLayout({ children }: { children: ReactNode }) {
  return <ScrollPageShell title="Workspaces">{children}</ScrollPageShell>;
}
